<template>
  <section class="container-fluid banner-section">
      <swiper class="swiper-desktop" :options="bannersOption">
        <swiper-slide v-for="banner in bannerFullWidth" :key="banner.id">
          <api-img :comp="banner.imagenes_id"  size="1920/450"/>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <swiper class="swiper-mobile" :options="bannersOption">
        <swiper-slide v-for="banner in bannerMovil" :key="banner.id">
          <api-img :comp="banner.imagenes_id"  size="1618/1000"/>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['catalogosGetBanners']),
        bannerFullWidth(){
            return _.filter(this.catalogosGetBanners, {uso: 'Web - Hero'})
        },
        bannerMovil(){
            return _.filter(this.catalogosGetBanners, {uso: 'Dispositivos y vertical'})
        }
    },
    props: {
        bannersOption: {
            type: [Object],
            default: () => {return {
                loop: true,
                speed:800,
                // effect: 'fade',

                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },

                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev'
                },

                autoplay: {
                delay: 7000,
                disableOnInteraction: false
                }
            }}
        }
    }
}
</script>

<style>

</style>